import { CollapsibleHeader } from '@/shared/components/GridTable/CollapsibleHeader/CollapsibleHeader'
import { GridColumnGroupingModel, GridColumnVisibilityModel } from '@mui/x-data-grid-premium'

export const columnGroupingModel: GridColumnGroupingModel = [
  {
    groupId: 'orderDetails',
    description: 'Details about the order',
    headerName: 'Order details',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={[
          'orderNumber', 'orderType', 'preferredDateOfOperation', 'weight', 'volume', 'orderQuantity', 'timeWindow',
          'serviceTime', 'priority', 'maxOnboardTime', 'portalClientName', 'displayOrderAttributes',
          'tripNumber', 'consignmentNumber', 'description', 'deliveryInstruction', 'comments', 'driverNote', 'stopCompartment',
        ]}
        numColumnsWhenCollapsed={3}
        {...params}
      />
    },
    children: [
      { field: 'orderNumber' },
      { field: 'orderType' },
      { field: 'preferredDateOfOperation' },
      { field: 'weight' },
      { field: 'volume' },
      { field: 'orderQuantity' },
      { field: 'timeWindow' },
      { field: 'serviceTime' },
      { field: 'priority' },
      { field: 'maxOnboardTime' },
      { field: 'portalClientName' },
      { field: 'displayOrderAttributes' },
      { field: 'tripNumber' },
      { field: 'consignmentNumber' },
      { field: 'description' },
      { field: 'deliveryInstruction' },
      { field: 'comments' },
      { field: 'driverNote' },
      { field: 'stopCompartment' },
    ],
  },
  {
    groupId: 'addressDetails',
    description: 'Address details',
    headerName: 'Address',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerAddress', 'customerSuburb', 'customerState', 'customerPostcode', 'customerMapRef', 'customerAdditional']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'customerAddress' },
      { field: 'customerSuburb' },
      { field: 'customerState' },
      { field: 'customerPostcode' },
      { field: 'customerMapRef' },
      { field: 'customerAdditional' },
    ],
  },
  {
    groupId: 'customerDetails',
    description: 'Customer details',
    headerName: 'Customer',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerNumber', 'customerName']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'customerNumber' },
      { field: 'customerName' },
    ],
  },
  {
    groupId: 'depotDetails',
    description: 'Depot details',
    headerName: 'Depot',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['depotCode', 'depotName']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'depotCode' },
      { field: 'depotName' },
    ],
  },
  {
    groupId: 'runningTotals',
    description: 'Running totals',
    headerName: 'Running Totals',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['runningWeight', 'runningVolume', 'runningQuantity', 'runningDistance', 'runningWorkingTime']}
        numColumnsWhenCollapsed={2}
        {...params}
      />
    },
    children: [
      { field: 'runningWeight' },
      { field: 'runningVolume' },
      { field: 'runningQuantity' },
      { field: 'runningDistance' },
      { field: 'runningWorkingTime' },
    ],
  },
]

export type ColumnGroupingModelResults = {
  columnGroupingModel: GridColumnGroupingModel
  initialColumnGroupVisibility: GridColumnVisibilityModel
}

// TODO: column grouping models should be dependent on the column definitions retrieved from the server.
export const useColumnGroupingModel = (): ColumnGroupingModelResults => {
  const initialColumnGroupVisibility: GridColumnVisibilityModel = {
    orderDetails: true,
    addressDetails: true,
    customerDetails: true,
    depotDetails: true,
    runningTotals: true,
  }

  return {
    columnGroupingModel,
    initialColumnGroupVisibility,
  }
}